// Simple storage adapters with a uniform interface

import type { StorageAdapter } from './storageService';

export const localAdapter: StorageAdapter = {
  get: (key: string): string | null => {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set: (key: string, value: string): void => {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // ignore quota or security errors
    }
  },
  remove: (key: string): void => {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // ignore
    }
  },
};

export const sessionAdapter: StorageAdapter = {
  get: (key: string): string | null => {
    try {
      return window.sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set: (key: string, value: string): void => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch {
      // ignore
    }
  },
  remove: (key: string): void => {
    try {
      window.sessionStorage.removeItem(key);
    } catch {
      // ignore
    }
  },
}; 